import { render, staticRenderFns } from "./changelogs.vue?vue&type=template&id=1d1f35f4&scoped=true"
import script from "./changelogs.vue?vue&type=script&lang=js"
export * from "./changelogs.vue?vue&type=script&lang=js"
import style0 from "./changelogs.vue?vue&type=style&index=0&id=1d1f35f4&prod&lang=less"
import style1 from "./changelogs.vue?vue&type=style&index=1&id=1d1f35f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1f35f4",
  null
  
)

export default component.exports